import * as React from 'react';
import ReactDOM from 'react-dom';

import get from 'lodash/get';

import GatewayConfig from 'app/src/data/models/GatewayConfig';
import BaseItemView from 'app/src/views/base/BaseItemView';
import Modules from 'shared_modules/Modules';

import { PaymentListItem } from './PaymentListItem';
import paymentViewTemplate from './templates/payment-list-item.hbs';

let _Events = {
  REMOVE_BUTTON_CLICKED: 'remove:button:clicked',
};

// configure
let View = BaseItemView.extend({
  tagName: 'tr',
  template: paymentViewTemplate,
  onRender() {
    if (
      get(
        this.options,
        'viewData.controller._paymentProvider.activeGateway.attributes.parameters.platformVersion',
        ''
      ) === GatewayConfig.PLATFORM_VERSIONS.v3
    )
      ReactDOM.render(<PaymentListItem viewData={this.viewData} model={this.model} />, this.el);
  },

  onDestroy() {
    ReactDOM.unmountComponentAtNode(this.el);
  },

  ui: {
    removePaymentButton: '.removeButton',
  },

  triggers: {
    'click @ui.removePaymentButton': _Events.REMOVE_BUTTON_CLICKED,
  },
});

// define
export default class PaymentListPaymentView extends View {
  getTemplate() {
    if (
      get(
        this.options,
        'viewData.controller._paymentProvider.activeGateway.attributes.parameters.platformVersion',
        ''
      ) === GatewayConfig.PLATFORM_VERSIONS.v3
    )
      return false;
    return paymentViewTemplate;
  }

  /**
   * Called by Marionette before the payment is rendered.  Here, we add custom
   * data into the view data which is passed as properties on the model.
   */
  onBeforeRender() {
    if (this.model.details) {
      this.viewData = this.viewData || {};
      this.viewData.details = this.model.details;
    }

    if (this.model.depositPayment) {
      this.viewData = this.viewData || {};
      this.viewData.depositPayment = this.model.depositPayment.toJSON();
      this.viewData.depositPayment.model.cardNumber = this.model.depositPayment.model.cardNumber;
    }
  }
}
